function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46 19c0 9.231-17.179 27.1-17.179 27.1S11.642 28.231 11.642 19 19.333 2.286 28.821 2.286 46 9.769 46 19z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.821,
  cy: 51.999,
  r: 2.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.821 46v4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33.446,
  cy: 46.499,
  r: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.446 41.2v3.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.446,
  cy: 41.499,
  r: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.446 36.2v3.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.446,
  cy: 35.899,
  r: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.446 30.6v3.2"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -24.247,
  cy: 46.499,
  r: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.247 41.2v3.2"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -20.247,
  cy: 41.499,
  r: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.247 36.2v3.2"
}), /*#__PURE__*/React.createElement("circle", {
  transform: "scale(-1 1)",
  cx: -16.247,
  cy: 35.899,
  r: 1.875,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.247 30.6v3.2"
}));

var SvgNecklace = function SvgNecklace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNecklace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Necklace.21937606.svg";
export { ForwardRef as ReactComponent };